import { useEffect, useState } from "react";
import { ChevronUp, FileText, Search } from "lucide-react";
import { splitDateTime } from "../../utils/generateDateTime.js";
import "./SessionList.css";
import useUserStore from "../../store/useUserStore.js";
import usePatientStore from "../../store/usePatientStore.js";
import { useNavigate } from "react-router-dom";
import useSurgicalStore from "../../store/useSurgicalStore.js";

// const SessionsList = ({ setIsSelectedPatient }) => {
const SurgicalList = () => {
  const navigate = useNavigate()
  const [isExpanded, setIsExpanded] = useState(false);
  const { user, fetchSurgicalData, allSurgicalSession,setActivePage } = useUserStore();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredList, setFilteredList] = useState(allSurgicalSession);
  const {surgicalId,currentSession,setTranscriptData,setAudioUrlData,setSurgicalNote,setCurrentSession,setSurgicalId,getSurgicalDetail}=useSurgicalStore()

  useEffect(() => {
    if (user) {
      fetchSurgicalData(user?.dentist_id);
    }
  }, [user, surgicalId]);

  useEffect(() => {
    setFilteredList(allSurgicalSession);
  }, [allSurgicalSession]);


  const handleSelectSession = async (session,surgicalId, name,ind) => {
    await setAllDataNull();
    setCurrentSession(session)
    setSurgicalId(surgicalId);
    navigate("/dashboard/selected-surgical-session")
    setActivePage("selected-surgical-session")
    await getSurgicalDetail(surgicalId);
    
  };

  const setAllDataNull = async () => {
    setTranscriptData(null);
    setAudioUrlData(null);
    setSurgicalNote(null);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);

    if (query === "") {
      setFilteredList(allSurgicalSession);
    } else {
      const filtered = allSurgicalSession.filter((session) =>
        session.patient_name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredList(filtered);
    }
  };

  

  return (
    <div className="sessions-container">
      <button
        className="sessions-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="header-content">
          <span className="icon">
            <FileText size={18} />
          </span>
          <span className="title">All Surgical Notes </span>
        </div>
        {/* <div className="flex items-center gap-2">
          {unread_count > 0 && (
            <span className="unread-badge">{unread_count}</span>
          )}
        </div> */}
        <ChevronUp className={`chevron ${!isExpanded ? "rotate" : ""}`} />
      </button>

      {isExpanded && (
        <div className="all-sessions">
          <div className="search-container">
            <div className="search-wrapper">
              <Search className="search-icon" size={14} />
              <input
                type="text"
                value={searchQuery}
                placeholder="Search sessions..."
                className="search-input"
                onChange={(e)=>handleSearch(e.target.value)}
              />
            </div>
          </div>

          <div className="sessions-list">
            {filteredList.map((session, index) => (
              <div
                key={index}
                className={`${
                  (currentSession?.surgical_id === session.surgical_id)
                    ? "session-item-selected"
                    : "session-item"
                }`}
                onClick={() =>
                  handleSelectSession(
                    session,
                    session?.surgical_id,
                    session?.patient_name,
                    index
                  )
                }
              >
                <div className="name-container">
                  <p className="patient-name">{session.patient_name}</p>
                  <div className="circular-dot" style={{backgroundColor:`${session?.is_surgical_note_generated ?"":'red'}`}}></div>
                </div>
                <div className="session-details">
                  <span className="session-time">
                    {splitDateTime(session?.created_date).date}{" "}
                    {splitDateTime(session?.created_date).time}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SurgicalList;
